'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'fan';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f863';
var svgPathData = ['M16.2 224c4.1 71.4 63.3 128 135.8 128 21.7 0 42.2-5.1 60.4-14.1 2.5-1.2 5.4-1.1 7.8 .4s3.8 4 3.8 6.8l0 150.7c71.4-4.1 128-63.3 128-135.8 0-21.7-5.1-42.2-14.1-60.4-1.2-2.5-1.1-5.4 .4-7.8s4-3.8 6.8-3.8l150.7 0c-4.1-71.4-63.3-128-135.8-128-21.7 0-42.2 5.1-60.4 14.1-2.5 1.2-5.4 1.1-7.8-.4s-3.8-4-3.8-6.8l0-150.7c-71.4 4.1-128 63.3-128 135.8 0 21.7 5.1 42.2 14.1 60.4 1.2 2.5 1.1 5.4-.4 7.8s-4 3.8-6.8 3.8L16.2 224zM288 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z', 'M160 152c0-72.4 56.6-131.6 128-135.8L288 167c0 2.8 1.4 5.3 3.8 6.8s5.3 1.6 7.8 .4c18.2-9 38.7-14.1 60.4-14.1 72.4 0 131.6 56.6 135.8 128L345 288c-2.8 0-5.3 1.4-6.8 3.8s-1.6 5.3-.4 7.8c9 18.2 14.1 38.7 14.1 60.4 0 72.4-56.6 131.6-128 135.8L224 345c0-2.8-1.4-5.3-3.8-6.8s-5.3-1.6-7.8-.4c-18.2 9-38.7 14.1-60.4 14.1-72.4 0-131.6-56.6-135.8-128L167 224c2.8 0 5.3-1.4 6.8-3.8s1.6-5.3 .4-7.8c-9-18.2-14.1-38.7-14.1-60.4zM296 0c-83.9 0-152 68.1-152 152 0 19.8 3.8 38.7 10.7 56L8 208c-4.4 0-8 3.6-8 8 0 83.9 68.1 152 152 152 19.8 0 38.7-3.8 56-10.6L208 504c0 4.4 3.6 8 8 8 83.9 0 152-68.1 152-152 0-19.8-3.8-38.7-10.6-56L504 304c4.4 0 8-3.6 8-8 0-83.9-68.1-152-152-152-19.8 0-38.7 3.8-56 10.7L304 8c0-4.4-3.6-8-8-8zM272 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFan = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;